import { Injectable } from '@angular/core';
import { Pin } from '../models/Pin';
import { SignatureCertificate } from '../models/SignatureCertificate';
import { SignatureRequestData } from '../models/SignatureRequestData';
import { SignatureResponseData } from '../models/SignatureResponseData';

@Injectable()
export class SignatureSessionService {
  public signatureRequestData: SignatureRequestData;
  public signatureResponseData: SignatureResponseData;
  public signatureCertificate: SignatureCertificate;
  public scwsCert: any;
  public scwsCerts: Array<any>;
  public scwsPkey: any;
  public pin: Pin;

  constructor() {
    this.clear();
  }

  public clear() {
    this.signatureRequestData = new SignatureRequestData();
    this.signatureResponseData = new SignatureResponseData();
    this.signatureCertificate = new SignatureCertificate();
    this.scwsCert = null;
    this.scwsCerts = [];
    this.scwsPkey = null;
    this.pin = new Pin();
  }
}
